import {getRandomString} from '../../util/string';

export const VIRTUAL_TABLE_CLASS = 'virtual-table';

export const DEFAULT_ROW_HEIGHT = 40;

export const DEFAULT_CHECKBOX_COLUMNS_WIDTH = 47;

export const CHECKBOX_DATA_INDEX = getRandomString();
